<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <div v-if="histories.length > 0">
        <v-simple-table v-if="!$vuetify.breakpoint.xs" dense fixed-header :height="200" style="width:100%">
            <thead>
                <tr>
                    <th v-if="sensors.length > 1">センサー</th>
                    <th>日時</th>
                    <th style="width:100%">異常</th>
                    <th>通知結果</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(history,index) in histories" :key="index" @click="onSelectedAlarm(history)" class="red--text">
                    <td v-if="sensors.length > 1">{{history.sensor.body.name}}</td>
                    <td>{{history.dateTime}}</td>
                    <td>{{history.alarm}}</td>
                    <td class="pa-0">
                        <v-chip 
                            v-if="history.notificated" 
                            label 
                            :color="history.isNotificationSuccess ? 'green--text' : 'red--text'" class="font-weight-bold mt-1 mb-1" 
                            @click.stop="onClickAlarmNotificationResult(history)">
                            {{history.notificationResultText}}
                        </v-chip>
                        <span v-else class="grey--text">{{history.notificationResultText}}</span>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
        <v-simple-table v-else dense fixed-header :height="200" >
            <tr v-for="(history,index) in histories" :key="index" class="red--text">
                <td>
                    <v-card outlined class="pa-1 ma-1" @click="onSelectedAlarm(history)">
                        <table style="width:100%">
                            <tr v-if="sensors.length > 1">
                                <td colspan="2" class="text-subtitle-1">
                                    {{history.sensor.body.name}}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-caption">{{history.dateTime}}</td>
                            </tr>
                            <tr>
                                <td class="text-caption">{{history.alarm}}</td>
                            </tr>
                            <tr>
                                <td class="text-caption">
                                    <v-chip 
                                        v-if="history.notificated" 
                                        label 
                                        small 
                                        :color="history.isNotificationSuccess ? 'green--text' : 'red--text'" 
                                        @click.stop="onClickAlarmNotificationResult(history)"
                                        class="font-weight-bold mt-1 mb-1">
                                        通知:{{history.notificationResultText}}
                                    </v-chip>
                                    <span v-else>{{history.notificationResultText}}</span>
                                </td>
                            </tr>
                        </table>
                    </v-card>
                </td>
            </tr>
        </v-simple-table >
        <NotificationHistories ref="notificationHistories" />
    </div>    
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import NotificationHistories from '@/components/box/SensorAlarmNotificationHistoryViewer';
    
    export default {
        components: {
            NotificationHistories
        },
        props: {
            sensors: null,
            alarmsOnChart: null
        },
        computed: {
            /**
             * 表示する警報履歴を格納した配列
             */
            histories: function () {
                const list = []

                if (this.sensors == null) return list

                for (var sensor of this.sensors) {
                    for (var alarmHistory of sensor.alarmHistories) {
                        const item = {
                            dateTime: (new Date(alarmHistory.time)).toFormatString("yyyy-MM-dd HH:mm"),
                            sensor: sensor,
                            alarm: "",
                            history: alarmHistory,
                            notification: null,
                            notificated: false,
                            isNotificationSuccess: false,
                            notificationResultText: "未通知"
                        }

                        switch (alarmHistory.alarmType) {
                            case 1:
                                item.alarm = "測定値が上限を超えました。("+alarmHistory.alarmData.value+")"
                                break;
                            case 2:
                                item.alarm = "測定値が下限を下回りました。("+alarmHistory.alarmData.value+")"
                                break;
                            case 3:
                                item.alarm = "センサー異常("+alarmHistory.alarmData.error+")"
                                break;
                        }

                        if (alarmHistory.notifications.length > 0) {
                            item.notificated = true
                            alarmHistory.notifications.sort(function(x, y){
                                if (x.time > y.time) return 1
                                if (x.time < y.time) return -1
                                return 0
                            })
                            const notification = alarmHistory.notifications[alarmHistory.notifications.length-1]
                            item.notification = notification

                            switch (notification.result) {
                                case 1:
                                    item.isNotificationSuccess = true
                                    item.notificationResultText = "成功"
                                    break;
                                case 2:
                                    item.isNotificationSuccess = false
                                    item.notificationResultText = "失敗"
                                    break;
                            }
                            // switch (notification.type) {
                            //     case 1:
                            //         switch (notification.result) {
                            //             case 1:
                            //                 item.isNotificationSuccess = true
                            //                 item.notificationResultText = "成功"
                            //                 break;
                            //             case 2:
                            //                 item.isNotificationSuccess = false
                            //                 item.notificationResultText = "失敗-("+notification.failedContent.failedNum+"回目)"
                            //                 switch (notification.failedContent.result) {
                            //                     case 1:
                            //                         item.notificationResultText += "-未応答"
                            //                         break;
                            //                     case 2:
                            //                         item.notificationResultText += "-話し中"
                            //                         break;
                            //                     case 3:
                            //                         item.notificationResultText += "-番号違い"
                            //                         break;
                            //                     case 4:
                            //                         item.notificationResultText += "-キャンセル"
                            //                         break;
                            //                 }
                            //                 break;
                            //                 switch (notification.failedContent.action) {
                            //                     case 1:
                            //                         item.notificationResultText += "-再通知"
                            //                         break;
                            //                 }
                            //         }
                            //         break;
                            //     case 11:
                            //         switch (notification.result) {
                            //             case 1:
                            //                 item.isNotificationSuccess = true
                            //                 item.notificationResultText = "成功"
                            //                 break;
                            //             case 2:
                            //                 item.isNotificationSuccess = false
                            //                 item.notificationResultText = "失敗"
                            //                 break;
                            //         }
                            //         break;
                            // }
                        }

                        list.push(item)
                    }
                }
                list.sort(function(x, y) {
                    if (x.sensor.body.sensorKey > y.sensor.body.sensorKey) return 1
                    if (x.sensor.body.sensorKey < y.sensor.body.sensorKey) return -1
                    if (x.dateTime > y.dateTime) return -1
                    if (x.dateTime < y.dateTime) return 1
                    return 0
                })

                // console.log("alarm histories", list)
                return list
            }
        },
        data: function () {
            return {
            }
        },
        methods: {
            /**
             * 警報履歴一覧の履歴選択時
             */
            onSelectedAlarm: function (history) {
                this.alarmsOnChart.splice(0, this.alarmsOnChart.length)
                const alarmData = {
                    time: history.history.time,
                    history: history.history
                }
                this.alarmsOnChart.push(alarmData)
            },
            /**
             * 通知結果押下時
             */
            onClickAlarmNotificationResult: function (history) {
                // console.log(history)
                this.$refs.notificationHistories.show(history)
            }
        }
    }
</script>
